/* global axios */
import ApiClient from './ApiClient';

class CadenciaAPI extends ApiClient {
  constructor() {
    super('cadencias', { accountScoped: true });
  }
}

export default new CadenciaAPI();
